export var BASE = "https://backend-dot-harbor-linclogix.uc.r.appspot.com";
if (process.env.NODE_ENV === "development") {
  BASE = "http://localhost:5000";
}

export const GET_DEVICE_INFO = BASE + "/deviceInfo/";
export const GET_ALL_PART_NUM = BASE + "/all/partNum";
export const GET_SEARCH = BASE + "/search/";
